'use client';

import { Monitor } from 'lucide-react';
import { PROJECT_NAME } from '@shared/constants';

/**
 * @group Doctors
 * @summary Features section for doctors page
 */
export function DoctorFeaturesSection() {
  const features = [
    'Control your schedule completely — work when it suits you, with as much or as little availability as you choose',
    'Intelligent dashboards provide triage summaries and AI-estimated vitals with clear confidence bands',
    'Clinical decision support suggests evidence-based protocols without overriding your judgement',
    'Wellbeing support and peer consultation available when needed',
  ];

  return (
    <section className="py-20 bg-hero-bg">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid lg:grid-cols-1 gap-12 items-start">
          {/* Content */}
          <div>
            <h2 className="text-3xl lg:text-4xl w-half font-bold text-hero-text mb-6">
              Reducing Burnout, Protecting Autonomy
            </h2>
            <p className="text-[#B8B4B0] mb-8 leading-relaxed">
              Medical professionals across South Africa face increasing pressure: overwhelming patient volumes, administrative burden, and the emotional toll of trying to serve more people than time allows. {PROJECT_NAME} aims to make your practice more sustainable whilst maintaining clinical standards.
            </p>
            <p className="text-[#B8B4B0] mb-8 leading-relaxed">
              Our platform handles appointment scheduling, patient triage, electronic prescriptions, and administrative documentation — allowing you to focus on what you trained for: providing excellent patient care.
            </p>
            
            <h3 className="text-xl font-semibold text-hero-text mb-4">Key Features for Clinicians</h3>
            <ul className="space-y-3">
              {features.map((feature, index) => (
                <li key={index} className="flex items-start">
                  <svg className="w-5 h-5 text-primary mr-3 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-[#B8B4B0] leading-relaxed">{feature}</span>
                </li>
              ))}
            </ul>
          </div>
          
          
        </div>
      </div>
    </section>
  );
}
